'use strict';
module.exports = function(app) {
    app.controller('productBiddingController', ['$scope', 'lodash', 'socket', 'syncDisPlayProductFactory', 'BiddingRateIncreaseFactory', 'FrontEndService', 'hotkeys', 'ngDialog', '$state', '$http', function($scope, _, socket, syncDisPlayProductFactory, BiddingRateIncreaseFactory, FrontEndService, hotkeys, ngDialog, $state, $http) {
        var defaultBidNumber = 59;
        $scope.magUrl = "";
        $scope.liveOfferBiddings = [];
        $scope.onlineOfferBiddings = [];
        $scope.liveOffer = 0;
        $scope.disable = false;
        var counter = 0;


        function successUpdateLiveOfferBidding (response) {
            if (response.length === 0) {
                 $scope.liveOfferBiddings = [{
                    'price' : 0,
                    'bid_number': defaultBidNumber
                }];
            } else {
                $scope.liveOfferBiddings = response;
            }
        }

        function successUpdateOnlineOfferBidding (response) {
            $scope.onlineOfferBiddings = response;
        }

        function successUpdateSelectedProduct(product) {

            //console.log('Online bidding is ' + ((product && product.online_bidding_locked) ? 'locked' : 'unlocked'));

            if (product) {
                //assign $scope.product again with selected product
                $scope.product = product;

                //if there is not bid make init value equal controlled_price
                if ($scope.product.$lastBid === undefined && $scope.product.controlled_price > 0 && ($scope.product.online_pre_price < $scope.product.controlled_price || $scope.product.online_pre_price === 0 )) {
                    $scope.liveOfferBiddings[0].increasedDealPrice = $scope.product.controlled_price - BiddingRateIncreaseFactory.amountCountReversed($scope.product.controlled_price);
                }
                else if ($scope.product.$lastBid === undefined && $scope.product.controlled_price > 0) {
                    $scope.liveOfferBiddings[0].increasedDealPrice = $scope.product.controlled_price;
                }
                else if ($scope.product.$lastBid === undefined && $scope.product.controlled_price === 0) {
                    $scope.liveOfferBiddings[0].increasedDealPrice = 10;
                }
                else if ($scope.product.$lastBid && $scope.product.$lastBid.verified && $scope.liveOfferBiddings.length > 0 && $scope.product.$lastBid.price > $scope.liveOfferBiddings[0].price) {
                    // update live price table if $lastBid is verified
                    $scope.liveOfferBiddings[0].increasedDealPrice = BiddingRateIncreaseFactory.autoIncreaseBidFn($scope.product.$lastBid.price);
                }

            }
        }

        function onConnectionError(err) {
            // only run on first connection_err event
                if (counter === 0) {
                    ngDialog.openConfirm({
                         template: require('../../template/modal_notify.html'),
                         plain: true,
                         closeByDocument: false,
                         closeByEscape: false,
                         showClose: false,
                         closeByNavigation: true
                    }).then(
                        function () {
                            $state.go('setting');
                        },
                        function () {
                            console.log('promises rejected');
                        }
                    );
                }

            counter++;
            socket.removeAllListeners();
        }


        FrontEndService.url().then(function onSuccess(response) {
           if (response.status === 200) {
               $scope.img_url = response.data.product_images_url;
           }
        });

        $scope.registerBid = function (increasedDealPrice, bid_number) {
            var bid_number = bid_number !== undefined && bid_number !== null ? bid_number : defaultBidNumber;
            if (increasedDealPrice) {
                socket.emit('create:bid', {
                    "products_id": $scope.product.products_id,
                    "price": increasedDealPrice,
                    "bid_number": bid_number
                });
            }
        };

        $scope.verifyBid = function (product, bid){
            socket.emit('verify:bid', {
               "products_id" : product.products_id,
                "bids_id": bid.bids_id
            });
        };

        $scope.sellToBidLive = function (products_id, bids_id, bid_number) {
            var bid_number = bid_number ? bid_number : defaultBidNumber;
            if (bid_number !== null && bids_id !== undefined && bids_id !== null && products_id === $scope.product.products_id) {
                socket.emit('sellTo:bid', {
                    "products_id": products_id,
                    "bid_number": bid_number,
                    "bids_id": bids_id
                });
            }
        };

         $scope.sellToBidOnLive = function (products_id, bids_id, bid_number) {
            if ( bids_id !== undefined && bids_id !== null && products_id === $scope.product.products_id) {
                socket.emit('sellTo:bid', {
                    "products_id": products_id,
                    "bid_number": bid_number,
                    "bids_id": bids_id
                });
            }
        };

        $scope.lock = function() {
            $scope.disable = true;
        };

        $scope.start = function (products_id) {
            socket.emit('admin:start', products_id);
            console.log('start');
        };

        $scope.stop = function (products_id) {
            socket.emit('admin:stop', products_id);
            console.log('stop');
        };

        $scope.adminPrev = function () {
            socket.emit('admin:prev');
        };

        $scope.adminNext = function () {
            socket.emit('admin:next');

        };

        $scope.adminMove = function (place) {
            socket.emit('admin:move', place);
        };


        //keyboard binding shortcut the UI, will be destroyed when the controller $scope destroyed
        hotkeys.bindTo($scope)
            .add({
                 combo: 'right',
                 callback: function() {
                     $scope.adminNext();
                 }
            })
            .add ({
                combo: 'left',
                callback: function () {
                    $scope.adminPrev();
                }
            })
            .add({
                combo: 'space',
                callback: function () {
                    //always binding the verify button of highest bid in onlive bidding table
                    if ($scope.onlineOfferBiddings.length > 0) {
                        $scope.verifyBid($scope.product, $scope.onlineOfferBiddings[0]);
                    }
                }
            }).add({
                combo: 'enter',
                callback: function () {
                    //always take the highest register bid
                    $scope.registerBid($scope.liveOfferBiddings[0].increasedDealPrice, $scope.liveOfferBiddings[0].bid_number );
                }});

        socket.on('update:customer', function (response) {
        });

        socket.on('success:create:bid', function (response) {
            console.log(response);
        });

        socket.on('backend:error', function (error) {
            console.log(error);
        });

        socket.on('update:liveOfferBiddings', successUpdateLiveOfferBidding);

        socket.on('update:product:selected',successUpdateSelectedProduct);

        socket.on('update:onlineOfferBiddings', successUpdateOnlineOfferBidding);

        socket.on('backend:error', function (error) {
            console.log(error);
        });
        socket.emit('get:model');

    //    connection error
        socket.on('connect_error', onConnectionError);
    }]);
};



/*****************
 ** WEBPACK FOOTER
 ** ./bidding_product/js/controller/biddingProduct.controller.js
 ** module id = 52
 ** module chunks = 0
 **/